// extracted by mini-css-extract-plugin
export default {"root":"mYI3pPLl","mobileSideOpen":"cPj0OSmw","shadowContent":"_u1wPgHG","asideHeader":"Lq9iS3YM","asideHeaderContent":"_WXxOunf","menuList":"kcrKJ_oV","systemInfo":"rcfoK9Ma"};